export const FilterValueType = {
  bool: 'Boolean',
  list: 'List',
  date: 'Date',
  dateTime: 'DateTime',
  time: 'Time',
  int: 'Integer',
  double: 'Double',
  UUID: 'UUID',
}
